import Firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const config = {
  apiKey: "AIzaSyCM0M3S-9uOreFi3mb6H5xNsFXx_Q5aLSw",
  authDomain: "disbon-clientes.firebaseapp.com",
  databaseURL: "https://disbon-clientes.firebaseio.com",
  projectId: "disbon-clientes",
  storageBucket: "disbon-clientes.appspot.com",
  messagingSenderId: "99274595246",
  appId: "1:99274595246:web:c575199e7db6d4bc"
};
Firebase.initializeApp(config);
const db = Firebase.firestore();
const auth = Firebase.auth();


const Clientes = db.collection('clientes');
const Rcas = db.collection('rcas');

export {
  db, 
  auth,
  Clientes,
  Rcas,
}